/* eslint-disable camelcase */
import { AreaJsonData } from '@/shared/utils/areaPicker/types';
import type { VerifyStageContext } from '@/views_v2/verify-credit/types';
import type { UserVo } from '@/vo/user';
import type { SelectOptionDataType } from '@hb/finance-ui/src/types/shared';

export interface StateType {
  formData: UserVo.PersonalInfo | null;
  /** 已填联系人 */
  userEmergencyContacts: [UserVo.ContactInfo, UserVo.ContactInfo] | null,
  userBaseId: string | null;
}

export enum ProfileFieldEnum {
  /** 通用固定字段 */
  EDUCATION_DEGREE = 'educationDegree',
  PRE_TAX_MONTH_SALARY = 'preTaxMonthSalary',
  LIVE_ADDRESS = 'liveAddress',
  LIVE_ADDRESS_DETAILS= 'liveAddressDetails',

  /** 提现动态补充字段  */
  PROFESSION = 'profession',
  MARITAL_STATUS = 'maritalStatus',
  COMPANY_NAME = 'companyName',

  /** 配偶作为联系人字段 */
  CONTACT_NAME = 'contactName',
  CONTACT_PHONE = 'contactPhone',
  CONTACT_RELATION = 'contactRelation'
}

export type AdditionalSupplyConfig = ProfileFieldEnum[];

export interface ContactItemInfo {
  contactName: string | undefined;
  contactPhone: string | undefined;
  contactRelation: string | number;
  contactRelation__0?: string | number;
  contactRelation__1?: string | number;
}

export type BaiscFormInstance = Record<string, SelectOptionDataType[]> & {
  formData: UserVo.PersonalInfo & ContactItemInfo;
  onFieldChange: (name: string, buttonName: string) => void;
}

export type ProfileInstance = BaiscFormInstance & {
  verifyStageContext: VerifyStageContext;
  shouldUpdateContacts: boolean;
}
/** 用户基础资料，通用需要填写的4个固定字段：学历、月薪、居住地、详细地址 */
export const CommonNeedFillStaticFields = [
  ProfileFieldEnum.EDUCATION_DEGREE,
  ProfileFieldEnum.PRE_TAX_MONTH_SALARY,
  ProfileFieldEnum.LIVE_ADDRESS,
  ProfileFieldEnum.LIVE_ADDRESS_DETAILS,
];
